import { AuthService } from "./auth.service"
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route, UrlTree, UrlSegment } from '@angular/router';
import { Observable } from 'rxjs';import { UserDetailsResponse } from "src/shared/service-proxies/service-proxies";
;
export interface NegateClaimData {
  claimType: string;
  route: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {


  constructor(private authService: AuthService, private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.authService.getUserDetails()
        .then((user) => {
          
          if (next.data["negateClaim"]) {
            // check the user doesnt have this claim if they do get the related redirect
            if (user !== null && this.userHasClaims(user, next.data["negateClaim"]) != null) {
              var claimData = this.userHasClaims(user, next.data["negateClaim"]);
              this.router.navigate([claimData.route]);
              resolve(false);
            } else {
              resolve(user !== null);  
            }
          } else {
            resolve(user !== null);
          }
      })
      .catch((error) => {
        reject(false);
      });
    });
  }

  userHasClaims(user: UserDetailsResponse, claims: NegateClaimData[]): NegateClaimData {
    let result = null;
    claims.forEach(claim => {
      user.userClaims.forEach(userClaim => {
        if (claim.claimType == userClaim.claimType) {
          result = claim;
        };
      });
    });

    return result;
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(next, state);
  }
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }

  checkUserLogin(route: ActivatedRouteSnapshot, url: any): boolean {
    if (this.authService.isSignedIn()) {
      const userRole = this.authService.getRole();
      if (route.data.role && route.data.role.indexOf(userRole) === -1) {
        this.router.navigate(['/home']);
        return false;
      }
      return true;
    }

    this.router.navigate(['/home']);
    return false;
  }
}